<template>
  <div class="container mt-4">
    <h2 class="mb-4 text-primary text-center">
      <font-awesome-icon :icon="['fas', 'users']" class="me-2" />
      Vincular Usuarios al Club
    </h2>

    <!-- Usuarios ya vinculados -->
    <div class="card shadow-sm p-3 mb-4">
      <h5>Usuarios del Club Actual</h5>
      <ul class="list-group">
        <li v-for="user in usuariosVinculados" :key="user.id" class="list-group-item d-flex justify-content-between align-items-center">
          {{ user.nombre }} - {{ user.email }}
          <span class="badge bg-success">{{ user.role?.nombre || 'Sin rol' }}</span>
          <button class="btn btn-outline-danger btn-sm" @click="desvincularUsuario(user)">
            <font-awesome-icon :icon="['fas', 'user-slash']" />
          </button>
        </li>
      </ul>
    </div>

    <!-- Buscador -->
    <div class="card shadow-sm p-3">
      <h5>Buscar Usuarios</h5>
      <input v-model="filtro" type="text" class="form-control" placeholder="Buscar por nombre o email..." />
      <button class="btn btn-primary mt-2" @click="buscarUsuarios">Buscar</button>

      <div v-if="resultadosBusqueda.length" class="mt-3">
        <h6>Resultados:</h6>
        <ul class="list-group">
          <li v-for="user in resultadosBusqueda" :key="user.id" class="list-group-item d-flex justify-content-between align-items-center">
            {{ user.nombre }} - {{ user.email }}
            <button class="btn btn-outline-success btn-sm" @click="vincularUsuario(user)">
              <font-awesome-icon :icon="['fas', 'user-plus']" />
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  data() {
    return {
      usuariosVinculados: [],
      resultadosBusqueda: [],
      roles: [],
      filtro: ''
    };
  },
  computed: {
    clubId() {
      return this.$store.state.clubActual.id;
    }
  },
  methods: {
    async cargarUsuariosVinculados() {
      try {
        const { data } = await axios.get('/api/usuarios_del_club', {
          params: { club_id: this.clubId },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.usuariosVinculados = data;
      } catch (error) {
        console.error('Error al cargar usuarios vinculados:', error);
      }
    },
    async buscarUsuarios() {
      if (!this.filtro) return;

      try {
        const { data } = await axios.get('/api/usuarios_buscar', {
          params: { query: this.filtro },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.resultadosBusqueda = data;
      } catch (error) {
        console.error('Error al buscar usuarios:', error);
      }
    },
    async vincularUsuario(user) {
      const rolClub = this.roles.find(r => r.nombre.toLowerCase() === 'club');
      if (!rolClub) return alert('No se encontró el rol "club".');
      if (this.usuariosVinculados.length >= 3) return alert('Máximo 3 usuarios.');

      if (!confirm(`¿Vincular a ${user.nombre}?`)) return;

      try {
        const { data } = await axios.post(
          '/api/usuarios_vincular',
          {
            user_id: user.id,
            club_id: this.clubId,
            role_id: rolClub.id
          },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        alert(data.mensaje);
        await this.cargarUsuariosVinculados();
        this.resultadosBusqueda = [];
        this.filtro = '';
      } catch (error) {
        console.error('Error al vincular usuario:', error);
        alert(error.response?.data?.error || 'Error al vincular usuario.');
      }
    },
    async desvincularUsuario(user) {
      if (!confirm(`¿Desvincular a ${user.nombre}?`)) return;
      try {
        await axios.post(
          '/api/usuarios_desvincular',
          { user_id: user.id },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        alert('Usuario desvinculado con éxito.');
        await this.cargarUsuariosVinculados();
      } catch (error) {
        console.error('Error al desvincular usuario:', error);
        alert(error.response?.data?.error || 'No se pudo desvincular');
      }
    },
    async cargarRoles() {
      try {
        const { data } = await axios.get('/api/roles', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.roles = data;
      } catch (error) {
        console.error('Error al cargar roles:', error);
      }
    }
  },
  mounted() {
    this.cargarUsuariosVinculados();
    this.cargarRoles();
  }
};
</script>


<style scoped>
.card h5 {
  margin-bottom: 1rem;
}

.page-link {
  cursor: pointer;
}
</style>
